import Hero from "../Hero";
import AboutSection from "../Section/AboutSection";
import Section from "../Section";
import TestimonialSection from "../Section/TestimonialSection";
import FaqSection from "../Section/FaqSection";
import AwardSection from "../Section/AwardSection";
import DepartmentSection from "../Section/DepartmentSection";
import { pageTitle } from "../../helpers/PageTitle";
import Spacing from "../Spacing";
import { awardData } from "../../utils/Data/awardData";
import { departmentData } from "../../utils/Data/departmentData";
import { faqData } from "../../utils/Data/faqData";
import { ArrowRight } from "lucide-react";
import HomeCarousel from "../Carousal/HomeCarousel";
import { useNavigate } from "react-router-dom";
import banner1 from "../../assets/update.jpg";


export default function Home() {
  const navigate = useNavigate();
  pageTitle("Home");
  return (
    <>
      <Hero
        title="Your Partner in Healthcare and Wellness"
        subTitle="Our dedicated specialists provide personalized care and innovative solutions to cure disease and guide you on your journey to optimal health and a fulfilling life."
        bgUrl="/images/nhwm/bg_cover.jpg"
        imgUrl="/images/home_1/hero_img.jpg"
        videoBtnText="Explore Our Strategy"
        videoUrl="https://youtu.be/LyNArsEwd3c"
        infoList={[
          {
            title: "Hotline",
            subTitle: "+91 3614516663 (Call)",
            subTitle2: "+91 9707076232 (WA & Call)",
            subTitle3: "+91 9707998887 (WA & Call)",
            href: "tel:+91 3614516663",
            href2: "tel:+91 9707076232",
            href3: "tel:+91 9707998887",
            iconUrl: "/images/contact/icon_1.svg",
          },
          {
            title: "Email",
            subTitle: "info@nhwm.in",
            href: "mailto:info@nhwm.in",
            iconUrl: "/images/contact/icon_2.svg",
          },
          {
            title: "Location",
            subTitle: "Karbi Namghar Path, Hengrabari, Borbari, Guwahati",
            href: "https://www.google.com/maps/place/National+Healthcare+%26+Wellness+Mission/@26.150227,91.8098962,17z/data=!4m14!1m7!3m6!1s0x375a59aa64f75da1:0xa9fa61749a2b8496!2sNational+Healthcare+%26+Wellness+Mission!8m2!3d26.150227!4d91.8098962!16s%2Fg%2F11ny0tcys6!3m5!1s0x375a59aa64f75da1:0xa9fa61749a2b8496!8m2!3d26.150227!4d91.8098962!16s%2Fg%2F11ny0tcys6?entry=ttu&g_ep=EgoyMDI1MDYwNC4wIKXMDSoASAFQAw%3D%3D",
            iconUrl: "/images/icons/pin.svg",
          },
        ]}
        btnText="Register Now"
        btnUrl="/register"
      />
      {/* Start Feature Section */}
      {/* <Section
        topMd={185}
        topLg={140}
        topXl={100}
        bottomMd={185}
        bottomLg={140}
        bottomXl={100}
      >
        <FeaturesSection sectionTitle="Our Services" data={featureListData} />
      </Section> */}
      {/* End Feature Section */}
      {/* Start About Section */}
      <Spacing xl="70" />
      <Spacing lg="10" />
      <Section>
        <AboutSection
          imgUrl="/images/nhwm/about_us_home.jpg"
          spiningImgUrl="/images/nhwm/logo.png"
          title="About Us"
          subTitle="Healthcare & Wellness Program"
          featureList={[
            {
              featureListTitle:
                "NHWM is a team of experienced Healthcare & Wellness professionals",
              featureListSubTitle:
                "NHWM is a collaboration of Optim Health and Wellness (OPC) Pvt. Ltd., a leading Organization for Healthcare & Wellness in India. We are educating & helping people to get prevented & reverse from Degenerative Lifestyle Diseases and educating people to maintain the Wellness by Free & Paid Healthcare & Wellness Services like Healthcare & Wellness Awareness & Education Service, Nutritional Healthcare & Wellness Assessment Services, Healthcare & Wellness Coaching & Training, Personalized Healthcare & Wellness Counselling. NHWM is offering Membership Registration Option to Indian citizens (Yearly, 5-Yearly & Life-time) who can take part in the Awareness Programmes as Part-Time worker or Full-Time employee. NHWM is the only organization in pan India engaging in Nutritional Assessment as well as Wellness Awareness Programmes since 2012 for all age groups along with expert guidance and counselling towards the prevention & reversal of all Degenerative Diseases like Diabetes, High BP, Heart Disease, Cancer, Arthritis, Obesity etc.",
            },
          ]}
        />
      </Section>
      {/* End About Section */}
      {/* Start Departments Section */}
      <Section>
        <HomeCarousel />
      </Section>

      <Section topMd={145} topLg={40} topXl={50}>
        <DepartmentSection
          sectionTitle="Our Expertise"
          bgUrl="images/home_1/department_bg.svg"
          data={departmentData}
        />
      </Section>
      <br />
      <div className="container w-full flex justify-center py-10 px-4">
        <div className="bg-[#42679e] max-w-5xl w-full rounded-xl shadow-2xl p-6 md:p-10 flex flex-col md:flex-row items-center gap-8 shadow-gray-800">
          <div className="w-full md:w-1/2">
            <img
              src={banner1}
              alt="Latest Updates"
              className="rounded-lg w-full object-cover"
            />
          </div>

          <div className="w-full md:w-1/2 text-white">
            <h2 className="text-3xl font-extrabold mb-4 text-center md:text-left text-white">
              LATEST UPDATES
            </h2>

            <p className="text-lg leading-relaxed">
              Stay updated with all our recent health awareness activities.
              Explore highlights from our latest camps, events, and wellness
              programs conducted across different regions.
            </p>

            <div className="flex justify-center mt-6 items-center">
              <button
                onClick={() => navigate("/Latest-update")}
                className="bg-white text-[#3BB3F5] font-semibold px-8 py-3 rounded-full text-lg shadow-md hover:scale-105 transition-transform"
              >
                CLICK HERE
              </button>
            </div>

            <p className="text-center md:text-left mt-3 font-semibold text-white tracking-wide">
              TO VIEW OUR LATEST UPDATES
            </p>
          </div>
        </div>
      </div>

      {/* End Departments Section */}
      {/* Start Award Section */}
      <Section topMd={105} topLg={50} topXl={20}>
        <div id="ourservices">
          <AwardSection sectionTitle="Our Services" data={awardData} />
        </div>
      </Section>
      {/* End Award Section */}
      {/* Start Testimonial */}
      <Section
        topMd={185}
        topLg={20}
        topXl={100}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <div id="testimonials">
          <TestimonialSection
            sectionTitle="Some Reviews"
            sectionTitleDown="Of Our Customers"
          />
        </div>
      </Section>
      {/* End Testimonial */}
      {/* Start Banner Section */}
      <div className="mt-[-90px]">
        <Section>
          <div className="container">
            <div
              className="cs_banner cs_style_1 cs_bg_filed flex"
              style={{ backgroundImage: `url(images/home_1/cta_bg.svg)` }}
            >
              <div>
                <h2 className="cs_banner_title cs_white_color cs_fs_72">
                  Don’t Let Your Health Take a Backseat!
                </h2>
                <p className="cs_banner_subtitle cs_heading_color cs_fs_20 cs_medium m-0">
                  Book your Free health session today that will be conducted in
                  your area by our specialist!
                </p>
              </div>
              <div className="md:flex justify-end hidden">
                <img
                  src="images/nhwm/checkup.jpg"
                  alt="Banner"
                  className="w-[65%]"
                  style={{ borderRadius: "5%" }}
                />
              </div>
            </div>
          </div>
        </Section>
      </div>
      {/* End Banner Section */}
      {/* Start Blog Section */}
      {/* <Section topMd={190} topLg={55} topXl={105}>
        <BlogSection
          sectionTitle="Latest Update"
          sectionTitleUp=""
          data={blogData}
        />
      </Section> */}
      {/* End Blog Section */}
      {/* Start Appointment Section */}
      <Section topMd={100} topLg={55} topXl={50} id="appointment">
        <div className="container">
          <div
            className="cs_banner cs_style_1 cs_bg_filed flex flex-col md:flex-row"
            style={{ backgroundImage: `url(images/home_1/cta_bg.svg)` }}
          >
            <div className="w-full md:flex md:flex-col justify-center items-center">
              <h2 className="text-center md:text-[5rem]">
                Want to Unlock Every Benefit We Offer ?
              </h2>
              <div className="flex justify-center my-4">
                <a
                  href="/register"
                  className="bg-[#307bc4] rounded-full px-4 md:px-8 md:py-4 py-2 text-lg text-white md:text-2xl md:font-medium hover:bg-[#356493] hover:shadow-md hover:shadow-gray-400 transition-all duration-400 ease-in-out flex gap-2 items-center"
                >
                  <span>Register Now</span>
                  <ArrowRight />
                </a>
              </div>
            </div>
            <div className="flex justify-end w-fit">
              <img
                src="/images/nhwm/registration.jpg"
                alt="Banner"
                className="md:w-[70%]"
                style={{ borderRadius: "5%" }}
              />
            </div>
          </div>
        </div>
        {/* <AppointmentSection
          sectionTitle="Registration"
          sectionTitleUp="Register Today"
          imgUrl="/images/nhwm/registration.jpg"
        /> */}
      </Section>
      {/* End Appointment Section */}
      {/* Start FAQ Section */}
      <Section topMd={190} topLg={55} topXl={105}>
        <div id="faq">
          <FaqSection
            data={faqData}
            sectionTitle="Usually Ask"
            sectionTitleUp="What People"
          />
        </div>
      </Section>
      {/* End FAQ Section */}
      {/* Start Brand Section */}
      <Section
        topMd={50}
        topLg={10}
        topXl={110}
        bottomMd={50}
        bottomLg={50}
        bottomXl={110}
      >
        {/* <BrandsSection data={brandData} /> */}
      </Section>
      {/* End Brand Section */}
    </>
  );
}

// using
